module.exports = __webpack_public_path__ + "static/media/library_mural_concept_2016.aac5a71c.webp";